import React from 'react';
import styled from 'styled-components';
import { Heading, spacing } from '@landr/maestro';
import { Trans } from '@lingui/macro';

export const Title = styled(Heading)`
    font-weight: bold;
    margin-bottom: ${spacing('xl')};

    ${({ theme }): string => theme.breakpoint('md')`
        margin-top: ${spacing('xl')};
    `};
`;

const ChooseYourPlan = () => (
    <Title size="xl">
        <Trans>Choose your plan</Trans>
    </Title>
);

export default ChooseYourPlan;
